export const INIT_REVIEWS = 'INIT_REVIEWS'
export const ADD_REVIEW = 'ADD_REVIEW'
